import React from "react";
import { HStack } from "@chakra-ui/react";
import HoneyIcon from "components/HoneyIcon";
import useTranslate from "hooks/useTranslate";
import WalletAsset from "components/WalletAsset";
import useAssets from "hooks/useAssets";
import useVesting from "hooks/useVesting";
import EtherAmount from "components/EtherAmount";

const WalletAssetsContainer: React.FC = () => {
  const translate = useTranslate();
  const { honeyBalance } = useAssets();

  const { vestingAmountRemaining } = useVesting();

  return (
    <HStack justify="stretch" spacing={3}>
      <WalletAsset
        title={translate("header:honey:title")}
        icon={HoneyIcon}
        value={<EtherAmount amount={honeyBalance} />}
      />

      <WalletAsset
        title={translate("header:vested:title")}
        icon={HoneyIcon}
        value={<EtherAmount amount={vestingAmountRemaining} />}
      />
    </HStack>
  );
};

export default WalletAssetsContainer;
